import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BUYING_PROMOTION } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerBulkBuyingPromotionModalGotItClicked = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BUYING_PROMOTION,
		name: 'dlr_bulk_buying_promotion_modal_got_it_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});
	logAnalyticsEvent({ eventPayload });
};
